import React from 'react';

import { DataPair } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/ContextData/DataPair';
import './EntityProperties.less';

export interface IEntityPropertiesProps {
  properties?: DataPair[];
}

const PROPERTIES_CLASS = 'dpc-properties-panel';

export function EntityProperties({ properties }: IEntityPropertiesProps) {
  return (
    <ul className={PROPERTIES_CLASS}>
      {properties &&
        properties.map((prop, i) => (
          <li key={i}>
            <p className={`${PROPERTIES_CLASS}__title`} title={prop.Name}>
              {prop.Name}:
            </p>
            <p className={`${PROPERTIES_CLASS}__value`} title={prop.OutputValue}>
              {prop.OutputValue}
            </p>
          </li>
        ))}
    </ul>
  );
}
